import Box from '@mui/material/Box';
import { useEffect, useRef } from 'react';
import playerProvider from '../../utils/playerProvider';
import {
  formatZones,
  getAllZonesEtages,
  getConfigSceneDefinition,
  getEtageByMediaName,
} from '../../utils';
import getSceneDefinition from '../../utils/getSceneDefinition';
import { useTheme } from '@mui/material/styles';

export default function MaquetteSituation({ infos, lot, interactive }) {
  const theme = useTheme();
  const PlayerContainerRef = useRef();
  const subscriber = useRef(true);
  const player = playerProvider.getInstance(
    interactive ? 'orbitalExt' : 'orbitalSitu',
  );
  const mainPlayer = playerProvider.getInstance('orbitalInt');

  const mediaBaseUrl = infos?.mediaBaseUrl;

  // Initialisation
  useEffect(() => {
    PlayerContainerRef.current.appendChild(player.getDomElement());
    if (!interactive) {
      subscriber.current = mainPlayer.rotator.rotateValue.subscribe(
        player.onRotate.bind(player),
      );
    }

    player.resize();
    window.addEventListener('resize', player.resize.bind(player));
    return () => {
      window.removeEventListener('resize', player.resize);
      if (!interactive) {
        subscriber.current.unsubscribe();
      }
    };
  }, [mainPlayer.rotator.rotateValue, player]);

  // Préparation maquette
  useEffect(() => {
    if (!lot) {
      console.log(`Lot not found`);
      return;
    }

    let zones = [];
    let frames = [];
    let mediaPath;
    let fovTerrain;

    const { settings, medias, lots } = infos;
    const isTypeTerrain = settings?.maquette?.type === 'terrain';

    if (isTypeTerrain) {
      mediaPath = 'Nu';
      frames = medias?.['Nu']?.frames;
      const zones1 = {
        [lot.key]: medias?.['Nu']?.zones?.[lot.key],
      };
      zones = formatZones(zones1, lots);
      fovTerrain = medias?.['Nu']?.fov;
    } else {
      const zonesEtages = getAllZonesEtages(infos.medias);
      const zonesLot = [];
      if (zonesEtages && zonesEtages[lot.key]) {
        zonesLot[lot.key] = [...zonesEtages[lot.key]];
      }

      const etageMedia = getEtageByMediaName(infos.medias, lot.key);

      zones = formatZones(zonesLot, infos.lots);
      mediaPath = etageMedia.path;
      frames = etageMedia.frames;
    }

    const { fps, loDef, hiDef, hasAlpha, fullpath, fov } =
      getConfigSceneDefinition(settings, { path: mediaPath }, mediaBaseUrl);

    const sceneDefinition = getSceneDefinition(
      fovTerrain || fov,
      fullpath,
      frames,
      [],
      zones,
      fps,
      loDef,
      hiDef,
      settings,
      hasAlpha,
      false,
      theme,
    );

    player.setScene(sceneDefinition, false);
  }, [mediaBaseUrl, lot, player, infos]);

  return (
    <Box
      ref={PlayerContainerRef}
      sx={{
        display: 'flex',
        width: '100%',
        height: '100%',
        position: 'absolute',
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          right: 0,
          left: 0,
          bottom: 0,
          opacity: 0.05,
          zIndex: 10,
          pointerEvents: 'none',
          backgroundImage:
            'radial-gradient(circle, rgba(2,0,36,0) 0%, rgba(1,0,20,0) 50%, rgba(0,0,0,3) 100%)',
        },
      }}
    ></Box>
  );
}
